/**
 * Most searched terms component.
 * @module components/theme/MostSearchedTerms/MostSearchedTerms
 */

import { useEffect } from 'react';
import { getSearchedTerms } from 'govbr.frontend.policy/actions/searched_terms/searched_terms';
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import TermsList from './TermsList';

const MostSearchedTerms = ({ searchInputFocused }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSearchedTerms());
  }, [dispatch]);

  const {
    most_searched_terms = [],
    n_desktop_terms = 5,
    n_mobile_terms = 3,
  } = useSelector((state) => state.searched_terms?.data);

  return (
    most_searched_terms?.length > 0 && (
      <>
        <TermsList
          terms={most_searched_terms}
          nTerms={n_desktop_terms}
          className={`desktop ${searchInputFocused ? 'open' : ''}`}
        />
        <TermsList
          terms={most_searched_terms}
          nTerms={n_mobile_terms}
          className={`mobile ${searchInputFocused ? 'open' : ''}`}
        />
      </>
    )
  );
};

MostSearchedTerms.propTypes = {
  searchInputFocused: PropTypes.bool,
};

export default MostSearchedTerms;
